import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// eslint-disable-next-line no-magic-numbers
export type LoaderSize = 16 | 18 | 24 | 32 | 40 | 48 | 64 | 128;
export const DEFAULT_DIAMETER: LoaderSize = 16;

@Component({
  selector: 'app-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinnerModule],
  template: `<mat-spinner [diameter]="size()"></mat-spinner>`,
})
export class LoaderComponent {
  readonly size = input<LoaderSize>(DEFAULT_DIAMETER);
}
